import React from 'react'
import Sidebar from '../components/_sidebar'
import { FormattedMessage } from 'react-intl';
import Img from 'gatsby-image';
import Link from 'components/Link';
import {Container} from 'reactstrap';

export default (props) => {

  const content = props.content;
  const image = props.data.ourTeamImg.childImageSharp.sizes;
  return (
    <Container>
      <Sidebar>
        <h3 className="mb-2"><FormattedMessage id="ourTeam" /></h3>
        <Img sizes={image} className="my-3" backgroundColor="rgba(51,102,255,0.4)"/>
        <p>{content.p1}</p>
        <br/>
        <p>{content.p2}</p>
        <br/>
        <p>{content.p3}</p>
        <br />
        <p>{content.p4}</p>
        <br/>
        <p>{content.p5}</p>
        <br/>
        <Link to="/" className="btn btn-lg btn-warning"><FormattedMessage id="joinUs" /></Link>
      </Sidebar>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/pages/about/our-team/_ourTeamLayout.js